import React, { useEffect } from 'react'
import { inject, observer } from 'mobx-react'
import UserMarkerfileSheetListItem from './UserMarkerfileSheetListItem'
import classnames from 'classnames'
import Toggle from 'components/common/Toggle'
import { checkboxIcon } from '../../../utils'
import { withTranslation } from 'react-i18next'

const UserMarkerfileSheetList = ({
  uiStore,
  selectionStore,
  userMarkerfileList,
  markerfile,
  t
}) => {
  useEffect(() => {
    if (markerfile && !markerfile.loaded && !markerfile.loading) {
      markerfile.load()
    }
  }, [markerfile])

  if (!markerfile) return null

  const markers = markerfile.markers || []

  return (
    <div className='marker-sheet-pane'>
      {/* Header Breadcrumb */}
      <div className='marker-sheet-pane__header'>
        <button
          type='button'
          className='marker-sheet-pane__back-btn'
          onClick={() => {
            userMarkerfileList.selectedFile = null
          }}
        >
          <svg
            width='14'
            height='14'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='2.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          >
            <polyline points='15 18 9 12 15 6' />
          </svg>
          <span>{t('GLOBAL.BACK', { defaultValue: 'Back' })}</span>
        </button>
        <span className='marker-sheet-pane__divider'>/</span>
        <span className='marker-sheet-pane__crumb'>
          {userMarkerfileList.editMode
            ? t('ITEM.MY_MARKERFILE', { defaultValue: 'My Markers' })
            : t('ITEM.MY_MARKERFILE_MARKERS', { defaultValue: 'My marker file markers' })}
        </span>
      </div>

      {/* File Title & Subtitle */}
      <div className='marker-sheet-pane__title-wrap'>
        <h2 className='marker-sheet-pane__title'>{markerfile.name}</h2>
        <p className='marker-sheet-pane__subtitle'>
          {t('GLOBAL.CHOOSE_MARKERS_SUBTITLE', {
            defaultValue: 'Choose Markers to add them to current selected Target Group'
          })}
        </p>
      </div>

      {/* Select All Row */}
      <div
        className={classnames('marker-sheet-pane__select-all', {
          disabled: markerfile.willExceededLimit
        })}
      >
        <span className='marker-sheet-pane__select-all-label'>
          {t('GLOBAL.SELECT_ALL', { defaultValue: 'Select All' })}
        </span>
        <Toggle
          icon={checkboxIcon(markerfile.allSelected)}
          enabled={markerfile.allSelected}
          onClick={() => {
            if (markerfile.allSelected) {
              markerfile.deselectAll()
            } else {
              markerfile.selectAll()
            }
          }}
        />
      </div>

      {/* Markers List */}
      <div className='marker-sheet-pane__list-wrap'>
        {markerfile.loading
          ? (
            <div className='marker-file-pane__loading'>
              <div className='marker-file-pane__spinner' />
              <span>{t('GLOBAL.LOADING', { defaultValue: 'Loading markers...' })}</span>
            </div>
            )
          : markers.length === 0
            ? (
              <div className='marker-file-pane__empty'>
                <span>{t('GLOBAL.NO_MARKERS_FOUND', { defaultValue: 'No markers found in this file' })}</span>
              </div>
              )
            : (
              <ul className='marker-sheet-pane__list'>
                {markers.map(marker => (
                  <UserMarkerfileSheetListItem
                    key={marker.id}
                    markerfile={markerfile}
                    marker={marker}
                    selected={markerfile.selectedMarker === marker}
                  />
                ))}
              </ul>
              )}
      </div>

      {/* Footer / Add Action */}
      <div className='marker-sheet-pane__footer'>
        <button
          type='button'
          className='marker-sheet-pane__btn-add'
          disabled={markerfile.selectedCount <= 0}
          onClick={e => {
            e.preventDefault()
            if (markerfile.group) {
              markerfile.uploadSelected()
            } else {
              userMarkerfileList.selectedFile = null
            }
          }}
        >
          <span>{t('GLOBAL.ADD', { defaultValue: 'Add' })}</span>
        </button>
      </div>
    </div>
  )
}

export default withTranslation()(inject('uiStore', 'selectionStore')(observer(UserMarkerfileSheetList)))
